import {useSuspenseQuery} from '@tanstack/react-query';
import {prepareSearchParams} from 'shared';

import {api} from '@/lib/ky';
import {extractPagination} from '@/utils/extractPagination';

import {assetListSchema} from '../utils/schemas/asset';

import {assetKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getAssets = async (params: QueryParams = {}) => {
  const res = await api.get(`assets`, {
    searchParams: prepareSearchParams(params),
  });
  const data = await res.json();
  const pagination = extractPagination(res);
  return [assetListSchema.parse(data), pagination] as const;
};

export const useAssets = (
  params?: QueryParams,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: assetKeys.list(params),
    queryFn: () => getAssets(params),
  });
};
export const useAssetsLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getAssets;
type QueryParams = Parameters<typeof assetKeys.list>[0];
